export default "__VITE_ASSET__03ab2172__"